import { SET_CITIES_LIST, SET_POPULAR_CITIES_LIST } from '../actions/formActions'

const initialState = {
    citiesList: null,
    popularCitiesList: null
}

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_CITIES_LIST:
            return { ...state, citiesList: action.payload }
        case SET_POPULAR_CITIES_LIST:
            return { ...state, popularCitiesList: action.payload }
        default:
            return state
    }
}